import React, { useState } from 'react';
import { LockIcon } from 'lucide-react';
interface LoginProps {
  onLogin: (password: string) => void;
}
export const Login: React.FC<LoginProps> = ({
  onLogin
}) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.trim()) {
      onLogin(password);
    } else {
      setError('Please enter a password');
    }
  };
  return <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-gray-100" data-id="element-69">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md" data-id="element-70">
        <div className="flex justify-center mb-6" data-id="element-71">
          <div className="bg-blue-600 p-4 rounded-full" data-id="element-72">
            <LockIcon size={32} className="text-white" data-id="element-73" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-center mb-2 text-gray-800" data-id="element-74">
          Currency Converter
        </h2>
        <p className="text-center text-gray-600 mb-6" data-id="element-75">
          Please enter the password to access the spreadsheet
        </p>
        <form onSubmit={handleSubmit} data-id="element-76">
          <div className="mb-4" data-id="element-77">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-78">
              Password
            </label>
            <input id="password" type="password" value={password} onChange={e => {
            setPassword(e.target.value);
            setError('');
          }} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Enter password" autoFocus data-id="element-79" />
          </div>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded-lg text-sm" data-id="element-80">
              {error}
            </div>}
          <button type="submit" className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-81">
            Access Spreadsheet
          </button>
        </form>
        <p className="text-center text-xs text-gray-500 mt-6" data-id="element-82">
          Contact the administrator if you need access
        </p>
      </div>
    </div>;
};